import { useState, useEffect, useCallback } from "react";
import { useAuth } from "./useAuth";

export const useTeamSettings = () => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { apiClient, teamId } = useAuth();

  const fetchSettings = useCallback(async () => {
    if (!teamId) return;

    setLoading(true);
    setError(null);

    try {
      const response = await apiClient.get(`/team-settings/${teamId}/`);
      setSettings(response.data);
    } catch (err) {
      console.error("Error fetching team settings:", err);
      if (err.response?.status !== 401) {
        setError("Failed to fetch team settings");
      }
    } finally {
      setLoading(false);
    }
  }, [apiClient, teamId]);

  useEffect(() => {
    fetchSettings();

    const handleSettingsChanged = () => {
      fetchSettings();
    };

    window.addEventListener("teamSettingsChanged", handleSettingsChanged);

    return () => {
      window.removeEventListener("teamSettingsChanged", handleSettingsChanged);
    };
  }, [fetchSettings]);

  return { settings, loading, error, refetch: fetchSettings };
};
